import React from 'react'

import classNames from 'classnames'

import { CommonSmallVerticalArrowIcon } from '@local/assets/icons'

import Clickable from '@web/components/Clickable'
import { UserRelationshipType } from '@web/gql/graphql'

import styles from './UserRelationshipMoreButton.module.scss'

const UserRelationshipMoreButton: React.FC<{
  onClickButtonMore(): void
  remains: number
  type?: UserRelationshipType
  clickCode?: string
}> = ({ onClickButtonMore, remains, type = UserRelationshipType.Follower, clickCode }) => {
  return (
    <Clickable
      className={classNames(styles.btn_more, { [styles.type_request]: type === UserRelationshipType.FollowRequester })}
      onClick={onClickButtonMore}
      nClickCode={clickCode}
    >
      {remains >= 10 ? 10 : remains}명 더보기
      <CommonSmallVerticalArrowIcon className={styles.icon} aria-hidden="true" />
    </Clickable>
  )
}

export default UserRelationshipMoreButton
